define 'controller/BasketController', ['jquery', 'lib/product-reviews','lib/kryptonite'], ($, reviews) ->
  class BasketController
  
    constructor: (@$el) ->
      @_addAdvantage()
      @_deleteAdvantage()
      @_deleteLineItemPopup()
      @_deleteLineItemPopupClose()
      @_deleteLineItem()
      @_changeLineItem()
      @_deleteAdvantageLineItem()
      @_applyAdvantageAdvantageFromRequestIfNecessary()
      @_addSameVariation()
      @_initMoveToWishlist()
      @_moveToWishlistPopup()
      @_moveToWishlistPopupClose()

    _addAdvantage: ->
      self = @
      $('.basket').on 'submit', '#advantageCode', (e) ->
        e.preventDefault()
        $form = $(@)
        $.kryptonite
          url: $form.attr('data-url')
          type: $form.attr('method')
          data:
            code: $form.find('input[name=code]').val()
          complete: ->

    _deleteAdvantage: ->
      self = @
      $('.basket').on 'click', '.basket__promo-code__delete a', (e) ->
        e.preventDefault()
        
        $link = $(@)
        url = $link.data('url')
        
        $.kryptonite
          url: url
          type: 'POST'
          complete: ->

    _deleteAdvantageLineItem: ->
      self = @
      $('.basket').on 'click', '.gift .line-item__delete a.delete', (e) ->
        e.preventDefault()
        $link = $(@)
        url = $link.data('url')

        $.kryptonite
          url: url
          type: 'POST'
          complete: ->
          
    _changeLineItem: ->
      self = @
      $('#lineItems').on 'click', '.line-item .line-item__modify a, [data-edit-lineitem]', (e) ->
        e.preventDefault()
        
        $link = $(@)
        url = $link.data('url')
        
        $.kryptonite
          url: url
          type: 'GET'
          complete: ->

    _deleteLineItemPopup: ->
      self = @
      $('#lineItems').on 'click', '.line-item .line-item__delete a', (e) ->
        e.preventDefault()
        $link = $(@)
        url = $link.data('url')

        $lineItem = $(e.target).closest('.line-item')
        $lineItem.find('.js-basket-delete-confirm').data("url", url)
        $lineItem.find('.basket__delete-confirm').show()

    _deleteLineItemPopupClose: ->
      self = @
      $('#lineItems').on 'click', '.js-basket-delete-confirm-close', (e) ->
        $lineItem = $(e.target).closest('.line-item')
        $lineItem.find('.basket__delete-confirm').hide()

    _deleteLineItem: ->
      self = @
      $('#lineItems').on 'click', '.js-basket-delete-confirm', (e) ->
        e.preventDefault()
        $link = $(@)
        url = $link.data('url')
        
        $.kryptonite
          url: url
          type: 'POST'
          complete: ->
            if dataLayer?
              variationExternalKey = $link.siblings('[name=variationExternalKey]').val()
              if (variationExternalKey)
                if (variationExternalKey.length == 10)
                  variationExternalKey = variationExternalKey.replace('_','00')
                else
                  variationExternalKey = variationExternalKey.replace('_','0')
              dataLayer.push({ 'event': '_removeFromCart', 'eventCategory': 'SmartFocus', 'eventAction': variationExternalKey, 'eventLabel': 'remove from basket' })

    _applyAdvantageAdvantageFromRequestIfNecessary: ->
      self = @
      $ ->
        requestedAdvantageFromRequest = $('input[name="advantageCodeFromRequest"]')
        if requestedAdvantageFromRequest && requestedAdvantageFromRequest.val()
          $('input[name="code"]').val(requestedAdvantageFromRequest.val())
          $('#advantageCode').submit()
          requestedAdvantageFromRequest.val('')

    _addSameVariation: ->
      self = @
      $('#lineItems').on 'click', '.line-item .line-item__addSameVariation a', (e) ->
        e.preventDefault()

        $link = $(@)
        url = $link.data('url')
        externalKeyVariation = $link.find('input[name="variationExternalKey"]').val()
        $.kryptonite
          url: url
          type: 'POST'
          data:
            variationExternalKey: externalKeyVariation

    _initMoveToWishlist: () ->
        self = @
        $('#lineItems').on 'click', '[data-move-to-wishlist]',  { self: self }, self._onMoveToWishlist
        $('#lineItems').on 'click', '[data-remove-from-wishlist]', { self: self }, self._onRemoveFromWishlist

    _onMoveToWishlist: (event) ->
      event.stopPropagation()
      event.preventDefault()
      self = event.data.self
      element = event.currentTarget
      variationId = element.dataset.moveToWishlist

      $.kryptonite
        url: window.location.pathname
        method: 'POST'
        data:
          'to_wishlist': variationId
      self._sendAddDataLayer variationId

    _onRemoveFromWishlist: (event) ->
      event.stopPropagation()
      event.preventDefault()

      self = event.data.self
      element = event.currentTarget
      variationId = element.dataset.removeFromWishlist

      $.kryptonite
        url: 'basket/removeFromWishlist'
        type: 'POST'
        data:
          externalKey: variationId
      self._sendRemoveDataLayer(variationId)

    _moveToWishlistPopup: ->
      timeout = window.setTimeout () ->
          $('.basket__wishlist-confirm').fadeOut(500)
      , 3000

    _moveToWishlistPopupClose: ->
      self = @
      $('.basket__wishlist-confirm').on 'click', '.js-basket-wishlist-confirm-close', (e) ->
        $('.basket__wishlist-confirm').hide()

    _sendAddDataLayer:(variationId) ->
      productId = variationId.substring(0,9)
      appendix = "addToWishlist?externalKey="+productId
      this._sendEvent(appendix, productId)

    _sendRemoveDataLayer:(variationId) ->
      productId = variationId.substring(0,9)
      appendix  ="removeFromWishlist?externalKey="+productId
      this._sendEvent(appendix , productId)

    _sendEvent: (appendix, prodRef) ->
      self = this
      $.ajax
        url: '/api/datalayer/event/' + appendix
        type: 'GET'
        xhrFields:
          showLoadingIndicator: false
        success: (content) ->
          if content == undefined
            return
          event = ""
          try
            event = JSON.parse(decodeURIComponent(escape(atob(content))))
          catch e
            event = JSON.parse(atob(content))
          $.ajax
            url: '/api/datalayer/event/avisData?externalKey=' + prodRef
            type: 'GET'
            xhrFields:
              showLoadingIndicator: false
            success: (data) ->
              siteId = data.siteId
              productKeys = data.concatenatedArticleRefs.split(',')
              reviews.retrieveRating siteId, productKeys, (rating) ->
                event.siteId = siteId
                event.avisRating = rating
                if event
                  dataLayer.push(event)
            failure: ->
              if event
                dataLayer.push(event)
    destroy: ->
      @$el.off()
